'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('selfAccessRequestControllers')

.controller('ArrivalPreAuthorizedBySystemTypeController',
    ['$scope', '$state', 'topBar', '$stateParams', '$timeout', '$translate', 'selfAccessRequest', 'processStep', 'selfAccessRequestService', 'decisionSystemTypesList', 'decisionBySystemType',
        function ($scope, $state, topBar, $stateParams, $timeout, $translate, selfAccessRequest, processStep, selfAccessRequestService, decisionSystemTypesList, decisionBySystemType) {

        var CURRENT_INDEX_SYSTEMTYPE = 0;

        $translate('iam.selfAccessRequest.arrival.preAuthorized.pageTitle').then(function(translation) {
            topBar.setTitleAndIcon(translation + ' &nbsp;<i class="fa fa-chevron-right fa-align"></i>&nbsp; ' +
                                   '<i class="' + processStep.CssIcon + '"></i> ' + processStep.StepTitleEN, 'fa-pencil-square-o');
        });

        // Assigning variables for Views
        $scope.currentSystemTypes = decisionSystemTypesList;
        $scope.currentSystemType = decisionBySystemType;

        $scope.processStep = processStep;
        $scope.NbSystems = decisionSystemTypesList.length;

        _.forEach(decisionSystemTypesList, function (system, index) {
            // Determine where we are in the array
            if (system.Slug === decisionBySystemType.Slug) {
                $scope.decisionsToConfirmCount = (decisionSystemTypesList.length - index) - 1;
                CURRENT_INDEX_SYSTEMTYPE = index;
                return;
            }
        });

        if ($scope.decisionsToConfirmCount === 0) {
            $scope.isLastSystemType = true;
        }
        if (($scope.decisionsToConfirmCount+ 1) === decisionSystemTypesList.length) {
            $scope.isFirstSystem = true;
        }


        $scope.currentUserId = selfAccessRequest.EmployeeID;

        // Go to selected System Type
        $scope.goToSystemType = function (systemType) {
            $state.go('selfAccessRequest.arrival.preAuthorizedBySystemType', {
                systemTypeSlug: systemType.Slug
            });
        }

        // Go to the next available systemType
        $scope.goToNextSystemType = function () {
            CURRENT_INDEX_SYSTEMTYPE = CURRENT_INDEX_SYSTEMTYPE + 1;
            if (CURRENT_INDEX_SYSTEMTYPE > ($scope.currentSystemTypes.length - 1))
                CURRENT_INDEX_SYSTEMTYPE = 0;
            $scope.goToSystemType($scope.currentSystemTypes[CURRENT_INDEX_SYSTEMTYPE]);

        }

        // Go to the previous available systemType
        $scope.goToPreviousSystemType = function () {
            CURRENT_INDEX_SYSTEMTYPE = CURRENT_INDEX_SYSTEMTYPE - 1;
            if (CURRENT_INDEX_SYSTEMTYPE < 0)
                CURRENT_INDEX_SYSTEMTYPE = $scope.currentSystemTypes.length - 1;
            $scope.goToSystemType($scope.currentSystemTypes[CURRENT_INDEX_SYSTEMTYPE]);
        }

        // Confirm Current System Decisions
        $scope.confirmSystemDecisions = function () {
            $scope.confirmInProgress = true;
            var currentUserSystemRoleDecisionList = [];
            _.forEach($scope.currentSystemType.SystemList, function (sysListItem) {
                _.forEach(sysListItem.UserSystemRoleDecisionList, function (decision) {
                    currentUserSystemRoleDecisionList.push(decision);
                })
            })

            selfAccessRequestService
             .confirmUserSystemRoleDecisionList($stateParams.userAccessRequestId, currentUserSystemRoleDecisionList)
             .then(function (data) {
                 $scope.confirmInProgress = false;
                 $scope.currentSystemType.IsCompleted = true;

                 var NEW_CURRENT_INDEX_SYSTEMTYPE = CURRENT_INDEX_SYSTEMTYPE;

                 for (var i = 0; i < $scope.currentSystemTypes.length; ++i) {
                     var idx = (i + CURRENT_INDEX_SYSTEMTYPE) % $scope.currentSystemTypes.length;
                     if (!$scope.currentSystemTypes[idx].IsCompleted) {
                         NEW_CURRENT_INDEX_SYSTEMTYPE = idx
                     }
                 }
                 $scope.goToNextSystemType();
             })
        }

        // Confirm all decisions and proceed to next step
        $scope.confirmSystemDecisionsAndStep = function () {

            //Gather all decisions
            $scope.confirmInProgress = true;
            var currentUserSystemRoleDecisionList = [];
            _.forEach($scope.currentSystemTypes, function (actualSystemType) {
                _.forEach(actualSystemType.SystemList, function (sysListItem) {
                    _.forEach(sysListItem.UserSystemRoleDecisionList, function (decision) {
                        currentUserSystemRoleDecisionList.push(decision);
                    })
                })
            })

            // Confirm gathered decisions
            selfAccessRequestService
             .confirmUserSystemRoleDecisionList($stateParams.userAccessRequestId, currentUserSystemRoleDecisionList)
             .then(function () {

                 selfAccessRequestService
                      .confirmProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, processStep.Step)
                      .then(function (selfAccessRequest) {
                          $scope.confirmInProgress = false;
                          $scope.currentSystemType.IsCompleted = true;
                          $state.go(selfAccessRequest.SelfRequestPageRoute, {}, { reload: true });
                      });

             })
        }

        // Confirm all systemtypes and Confirm Step
        $scope.confirmAll = function () {

            //Confirm the last step before
            var currentUserSystemRoleDecisionList = [];
            _.forEach($scope.currentSystemType.SystemList, function (sysListItem) {
                _.forEach(sysListItem.UserSystemRoleDecisionList, function (decision) {
                    currentUserSystemRoleDecisionList.push(decision);
                })
            })

            // Confirm whole process
            selfAccessRequestService
             .confirmUserSystemRoleDecisionList($stateParams.userAccessRequestId, currentUserSystemRoleDecisionList)
             .then(function (data) {
                 selfAccessRequestService
                    .confirmProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, processStep.Step)
                    .then(function (selfAccessRequest) {
                        $state.go(selfAccessRequest.SelfRequestPageRoute,{}, {reload:true});
                    });
             })
        }

        // Go to Arrival HomePage
        $scope.goToArrival = function () {
            $state.go('selfAccessRequest', {
                userAccessRequestId: $stateParams.userAccessRequestId
            }, {
                reload: true
            });
        }

        // Reset Ownership
        $scope.resetOwnership = function () {
            selfAccessRequestService.cancelSelfAccessRequestOwnership($stateParams.userAccessRequestId)
             .then(function (response) {
                 window.location = environment.iamUrl;
                 // replace by url redirect
             });
        }

    }
]);
